import { sameLayout } from "../domain/layout";
import { findPresetForRenderIdentity as findCompatiblePreset } from "./compatibility";
import { bus6Preset } from "./bus";
import { car4Preset } from "./car4";
import { jcb4Preset } from "./jcb";
import { mixer10Preset, mixer6Preset } from "./mixer";
import { trailer12Preset, trailer8Preset } from "./trailer";
import { wheelLoader4Preset } from "./wheelLoader";
import { rigidHaulTruck6Preset } from "./rigidHaulTruck";
import { adt6Preset } from "./adt";
import { waterTanker10Preset } from "./waterTanker";
import { OPERATIONAL_FLEET_PRESETS } from "./operationalFleet";
import {
  truck10Preset,
  truck12Preset,
  truck16Preset,
  truck4Preset,
  truck6Preset,
  truck6ThreeSinglePreset
} from "./truck";
import { presetKey } from "./types";
const PRESETS = [
  car4Preset,
  truck6Preset,
  truck6ThreeSinglePreset,
  truck10Preset,
  truck12Preset,
  truck16Preset,
  truck4Preset,
  bus6Preset,
  jcb4Preset,
  mixer10Preset,
  mixer6Preset,
  wheelLoader4Preset,
  rigidHaulTruck6Preset,
  adt6Preset,
  waterTanker10Preset,
  ...OPERATIONAL_FLEET_PRESETS,
  trailer12Preset,
  trailer8Preset
];
const BY_KEY = /* @__PURE__ */ new Map();
PRESETS.forEach((preset) => {
  const key = presetKey(preset.renderModelKey, preset.renderLayoutKey);
  if (BY_KEY.has(key)) throw new Error(`Duplicate render compatibility key: ${key}`);
  BY_KEY.set(key, preset);
});
const ALL_PRESETS = PRESETS;
const presetCandidates = (renderModelKey, renderLayoutKey) => {
  const preset = BY_KEY.get(presetKey(renderModelKey, renderLayoutKey));
  return preset ? [preset] : [];
};
const findPresetForRenderIdentity = (identity, vehicle) => findCompatiblePreset(PRESETS, identity, vehicle);
const presetFitsVehicle = (preset, vehicle) => sameLayout(preset.layout, vehicle.layout);
export {
  ALL_PRESETS,
  findPresetForRenderIdentity,
  presetCandidates,
  presetFitsVehicle
};
